import apiFetch from '../apiFetch'

export default function (token, body) {
  return apiFetch({ endPoint: 'OrganizedUnit/DirectionOU', method: 'PUT', body: body, token: token })
}
